import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-position",
  "use": "icon-icon-position-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-position\">\n<rect width=\"40\" height=\"40\" fill=\"#D8D8D8\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.66667 18.541L21.5368 34.1664L30.3333 27.7753L40 39.3334H0L6.66667 18.541Z\" fill=\"#ECECEC\" />\n<circle cx=\"26.3333\" cy=\"10.3333\" r=\"4.33333\" fill=\"#ECECEC\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol